import React from 'react'

import ConditionSvgs from './ConditionSvgs'
import IconSvgs from './IconSvgs'
import ConditionPage from './ConditionPage'

export default ({ prospectDocuments, interiorSeatRows, ...props }) => {
  const conditionQuestions = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qc').items.filter(item => item.section === 'Vehicle Condition')
  const title = conditionQuestions && conditionQuestions[0] ? conditionQuestions[0].section : 'n/a'

  const svgItems = ['GlassLights' + interiorSeatRows]
  const svgIcons = ['Tires & Rims', 'Brakes']
  return (
    <ConditionPage {...{ title, conditionQuestions, svgItems, svgIcons, ...props }} pageName={'glass'} noDamage={'No issues with glass, wheels or brakes? Select Next.'}>
      <ConditionSvgs width={360} height={450} {...{ conditionQuestions, svgItems, ...props }} />
      <IconSvgs {...{ svgIcons, conditionQuestions, ...props }} />
    </ConditionPage>
  )
}
